export default "__VITE_ASSET__D7q6I$5N__"